import {
  questionsConstants
} from '../_constants';

export function questions(state = {}, action) {
  // console.log('state',state,action)
  switch (action.type) {


    case questionsConstants.QUESTIONS_GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.QUESTIONS_GETALL_SUCCESS:
      return {
        ...state,
        questionsList: action.questions.questionsList,
        answersList: action.questions.answersList,
        surveyScreenData: action.questions.surveyScreenData,
        surveyStatus: action.questions.surveyStatus,
        langList: action.questions.langList,
        GroupQuestionOnlyList: action.questions.GroupQuestionOnlyList



      };
    case questionsConstants.QUESTIONS_GETALL_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.QUESTIONS_LIST_GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.QUESTIONS_LIST_GETALL_SUCCESS:
      return {
        ...state,
        questionsList: action.questions.questionsList,
        answersList: action.questions.answersList,
        surveyScreenData: action.questions.surveyScreenData,
        surveyStatus: action.questions.surveyStatus,
        GroupQuestionOnlyList: action.questions.GroupQuestionOnlyList


      };
    case questionsConstants.QUESTIONS_LIST_GETALL_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.ANSWERS_SUBMIT_REQUEST:
      return {
        ...state,
        answerSubmitSuccess: false,
      };
    case questionsConstants.ANSWERS_SUBMIT_SUCCESS:
      return {
        ...state,
        answerSubmitSuccess: true,
        questionsList: action.questions.questionsList,
        answersList: action.questions.answersList,
        surveyScreenData: action.questions.surveyScreenData,
        surveyStatus: action.questions.surveyStatus,
        langList: action.questions.langList,
        GroupQuestionOnlyList: action.questions.GroupQuestionOnlyList
      };
    case questionsConstants.ANSWERS_SUBMIT_FAILURE:
      return {
        ...state,
        error: action.error,
        answerSubmitSuccess: false,
        submitfail: true
      };





    case questionsConstants.ANSWERS_ASSESSMENT_SUBMIT_REQUEST:
      return {
        ...state
      };
    case questionsConstants.ANSWERS_ASSESSMENT_SUBMIT_SUCCESS:
      return {
        ...state,
        answerSubmitSuccess: true,
        questionsList: action.questions.questionsList,
        answersList: action.questions.answersList,
        surveyScreenData: action.questions.surveyScreenData,
        surveyStatus: action.questions.surveyStatus,
        langList: action.questions.langList,
        GroupQuestionOnlyList: action.questions.GroupQuestionOnlyList
      };
    case questionsConstants.ANSWERS_ASSESSMENT_SUBMIT_FAILURE:
      return {
        ...state,
        error: action.error,
        submitfail: true
      };





    case questionsConstants.EMPTY_REDUCER:
      return {
        ...state,
        questionsList: action.questions.questionsList,
        answersList: action.questions.answersList,
        surveyScreenData: action.questions.surveyScreenData,
        surveyStatus: action.questions.surveyStatus
      };






    case questionsConstants.GET_LANGUAGE_LABEL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_LANGUAGE_LABEL_SUCCESS:
      return {
        ...state,
        getLanguageLabelSuccess: true,
        getLanguageLabelData: action.questions.getLanguageLabelData

      };
    case questionsConstants.GET_LANGUAGE_LABEL_FAILURE:
      return {
        ...state,
        error: action.error
      };






    case questionsConstants.GET_SURVEY_TEMPLATE_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_SURVEY_TEMPLATE_CODE_SUCCESS:
      return {
        ...state,
        getSurveyTemplateByCodeDataSuccess: true,
        getSurveyTemplateByCodeData: action.questions.getSurveyTemplateByCodeData

      };
    case questionsConstants.GET_SURVEY_TEMPLATE_CODE_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_SUCCESS:
      return {
        ...state,
        getSurveyTemplateByCodeDataSuccess: true,
        getSurveyTemplateByCodeData: action.questions.getSurveyTemplateByCodeData

      };
    case questionsConstants.GET_ASSESSMENT_SURVEY_TEMPLATE_CODE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.GET_SURVEY_TEMPLATE_SURVEY_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_SURVEY_TEMPLATE_SURVEY_CODE_SUCCESS:
      return {
        ...state,
        getSurveyDetailsBySurveyCodeSuccess: true,
        getSurveyDetailsBySurveyCodeData: action.questions.getSurveyDetailsBySurveyCodeData

      };
    case questionsConstants.GET_SURVEY_TEMPLATE_SURVEY_CODE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.GET_EMPLOYEE_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_EMPLOYEE_STATUS_SUCCESS:
      return {
        ...state,
        getEmployeeStatusSuccess: true,
        getEmployeeStatusFailed: false,
        getEmployeeStatusData: action.questions.getEmployeeStatusData
      };
    case questionsConstants.GET_EMPLOYEE_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
        employeeMessage: action.error,
        getEmployeeStatusFailed: true,
        getEmployeeStatusSuccess: false
      };




    case questionsConstants.GET_RESPONDANT_NAME_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_RESPONDANT_NAME_SUCCESS:
      return {
        ...state,
        getRespondantNameSuccess: true,
        getRespondantNameData: action.questions.getRespondantNameData

      };
    case questionsConstants.GET_RESPONDANT_NAME_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_ASSESSMENT_EMPLOYEE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_ASSESSMENT_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        getAssessmenrEmployeeDetailsSuccess: true,
        getAssessmenrEmployeeDetailsData: action.questions.getAssessmenrEmployeeDetailsData

      };
    case questionsConstants.GET_ASSESSMENT_EMPLOYEE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_ACCESSMENT_REPORT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_ACCESSMENT_REPORT_SUCCESS:
      return {
        ...state,
        getAssessmentReportSuccess: true,
        getAssessmentReportByEmpIDData: action.questions.getAssessmentReportData

      };
    case questionsConstants.GET_ACCESSMENT_REPORT_FAILURE:
      return {
        ...state,
        error: action.error
      };


    case questionsConstants.GET_ACCESSMENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_ACCESSMENT_STATUS_SUCCESS:
      return {
        ...state,
        getAssessmentStatusSuccess: true,
        getAssessmentStatusData: action.questions.getAssessmentStatusData

      };
    case questionsConstants.GET_ACCESSMENT_STATUS_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_TRANSLATE_ELEMENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_TRANSLATE_ELEMENT_SUCCESS:
      return {
        ...state,
        getTranslateElementAllSuccess: true,
        getTranslateElementAllData: action.questions.getTranslateElementAllData

      };
    case questionsConstants.GET_TRANSLATE_ELEMENT_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.GET_SURVEY_DESIGN_BY_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_SURVEY_DESIGN_BY_CODE_SUCCESS:
      return {
        ...state,
        getSurveyDesignByCodeSuccess: true,
        getSurveyDesignByCodeData: action.questions.getSurveyDesignByCodeData

      };
    case questionsConstants.GET_SURVEY_DESIGN_BY_CODE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.GET_EMP_DMG_VALUES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_EMP_DMG_VALUES_SUCCESS:
      return {
        ...state,
        getEMPWiseDemographicValueSuccess: true,
        getEMPWiseDemographicValueData: action.questions.getEMPWiseDemographicValueData

      };
    case questionsConstants.GET_EMP_DMG_VALUES_FAILURE:
      return {
        ...state,
        error: action.error
      };






    case questionsConstants.SAVE_SURVEY_CONSENT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.SAVE_SURVEY_CONSENT_SUCCESS:
      return {
        ...state,
        saveSurveyConsentSuccess: true,
        saveSurveyConsentData: action.questions.saveSurveyConsentData

      };
    case questionsConstants.SAVE_SURVEY_CONSENT_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_LEADERSHIP_REPORT_SCORE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_LEADERSHIP_REPORT_SCORE_SUCCESS:
      return {
        ...state,
        getLeadershipReportScore_USERSuccess: true,
        getLeadershipReportScore_USERData: action.questions.getLeadershipReportScore_USERData

      };
    case questionsConstants.GET_LEADERSHIP_REPORT_SCORE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.GET_LEADERSHIP_PARA_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_LEADERSHIP_PARA_CATEGORY_SUCCESS:
      return {
        ...state,
        getLeadershipParaCategory_USERSuccess: true,
        getLeadershipParaCategory_USERData: action.questions.getLeadershipParaCategory_USERData

      };
    case questionsConstants.GET_LEADERSHIP_PARA_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case questionsConstants.GET_LEADERSHIP_TEXT_DETAILS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_LEADERSHIP_TEXT_DETAILS_SUCCESS:
      return {
        ...state,
        getLeadershipTextDetails_USERSuccess: true,
        getLeadershipTextDetails_USERData: action.questions.getLeadershipTextDetails_USERData

      };
    case questionsConstants.GET_LEADERSHIP_TEXT_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error
      };





    case questionsConstants.GET_INSIGHT_SURVEY_CODE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_INSIGHT_SURVEY_CODE_SUCCESS:
      return {
        ...state,
        getInsightSurveyCodeSuccess: true,
        getInsightSurveyCodeData: action.questions.getInsightSurveyCodeData

      };
    case questionsConstants.GET_INSIGHT_SURVEY_CODE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case questionsConstants.SAVE_CHEAT_LOGS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.SAVE_CHEAT_LOGS_SUCCESS:
      return {
        ...state,
        saveInsightAnswersSuccess: true,
        saveInsightAnswersData: action.questions.saveInsightAnswersData
      };
    case questionsConstants.SAVE_CHEAT_LOGS_FAILURE:
      return {
        ...state,
        error: action.error
      };


    case questionsConstants.GET_LAST_SAVE_QUESTION_REQUEST:
      return {
        ...state,
        loading: true
      };
    case questionsConstants.GET_LAST_SAVE_QUESTION_SUCCESS:
      return {
        ...state,
        getLastSaveQuestionSuccess: true,
        getLastSaveQuestionData: action.questions.getLastSaveQuestionData
      };
    case questionsConstants.GET_LAST_SAVE_QUESTION_FAILURE:
      return {
        ...state,
        error: action.error
      };



    default:
      return state
  }
}